import { CustomPagination } from "./CustomPagination";

export default CustomPagination;
